var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page zntjMd" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "sort-condition" }, [
          _vm.NODE_ENV != "erp" && _vm.NODE_ENV != "erp-prod"
            ? _c("div", { staticClass: "stItem stImType" }, [
                _c("span", { staticClass: "ss" }, [_vm._v("执行人")]),
                _c(
                  "div",
                  { staticClass: "stType" },
                  [
                    _vm.staffInfo.accountType.code === 0
                      ? [
                          _vm.employeeName
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.employeeName)),
                                _c("i", {
                                  staticClass:
                                    "el-tag__close tficon-shanchubiaoqianmoren tficonfont",
                                  on: { click: _vm.deleteName },
                                }),
                              ])
                            : [
                                _c("div", { on: { click: _vm.addStaff } }, [
                                  _vm._m(0),
                                  _vm._v("添加 "),
                                ]),
                              ],
                        ]
                      : _c("span", [_vm._v(_vm._s(_vm.staffInfo.nickName))]),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "stItem stImTime" }, [
            _c("span", { staticClass: "ss" }, [_vm._v("创建时间")]),
            _c(
              "div",
              { staticClass: "stType" },
              [
                _c(
                  "span",
                  {
                    class: _vm.timeType == 4 ? "active2" : "",
                    on: {
                      click: function ($event) {
                        return _vm.sortCleaningTime(4)
                      },
                    },
                  },
                  [_vm._v("全部")]
                ),
                _c(
                  "span",
                  {
                    class: _vm.timeType == 1 ? "active2" : "",
                    on: {
                      click: function ($event) {
                        return _vm.sortCleaningTime(1)
                      },
                    },
                  },
                  [_vm._v("今天")]
                ),
                _c(
                  "span",
                  {
                    class: _vm.timeType == 2 ? "active2" : "",
                    on: {
                      click: function ($event) {
                        return _vm.sortCleaningTime(2)
                      },
                    },
                  },
                  [_vm._v("昨天")]
                ),
                _c(
                  "span",
                  {
                    class: _vm.timeType == 3 ? "active2" : "",
                    on: {
                      click: function ($event) {
                        return _vm.sortCleaningTime(3)
                      },
                    },
                  },
                  [_vm._v("近7天")]
                ),
                _c("el-date-picker", {
                  staticClass: "mr-16",
                  attrs: {
                    "value-format": "yyyy-MM-dd",
                    "picker-options": _vm.pickerOptions,
                    "unlink-panels": "",
                    "range-separator": "~",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    type: "daterange",
                    size: "small",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.sortCleaningTime(5)
                    },
                  },
                  model: {
                    value: _vm.date,
                    callback: function ($$v) {
                      _vm.date = $$v
                    },
                    expression: "date",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.waiting,
              expression: "waiting",
            },
          ],
          staticClass: "intelBox",
        },
        [
          _c(
            "div",
            { staticClass: "number-infor" },
            [
              _c("div", { staticClass: "titile" }, [_vm._v("号码清洗统计")]),
              _c("div", { staticClass: "numItem" }, [
                _c("div", { staticClass: "total" }, [
                  _c("span", { staticClass: "ttNum" }, [
                    _vm._v(_vm._s(_vm.numberTotal)),
                  ]),
                  _c("span", { staticClass: "ttTxt" }, [_vm._v("号码总数")]),
                ]),
                _c(
                  "div",
                  { staticClass: "total-sort" },
                  _vm._l(_vm.numberStatusCircle, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "item" },
                      [
                        _c("el-progress", {
                          class: "pgs" + index,
                          attrs: {
                            type: "circle",
                            width: 60,
                            "stroke-width": 8,
                            percentage: item.percentage,
                            color: item.color,
                          },
                        }),
                        _c("p", [
                          _c("span", { staticClass: "ttNum" }, [
                            _vm._v(_vm._s(item.num)),
                          ]),
                          _c("span", { staticClass: "ttTxt" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _c("div", { staticClass: "smallTit" }, [
                _vm._v("号码清洗记录   共 "),
                _c("span", { staticStyle: { color: "#5088FF" } }, [
                  _vm._v(_vm._s(this.list.total)),
                ]),
                _vm._v(" 个任务"),
              ]),
              _c(
                "el-table",
                {
                  staticClass: "cleaningTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.list.tableData, innerpage: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "任务名称",
                      "min-width": "145",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "light",
                                  content: scope.row.name,
                                  placement: "top",
                                },
                              },
                              [
                                _c("span", { staticClass: "textOverflow" }, [
                                  _vm._v(_vm._s(scope.row.name)),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "nickName",
                      label: "执行人",
                      "min-width": "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "light",
                                  content: scope.row.nickName,
                                  placement: "top",
                                },
                              },
                              [
                                _c("span", { staticClass: "textOverflow" }, [
                                  _vm._v(_vm._s(scope.row.nickName)),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "创建时间",
                      "min-width": "130",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "checkState", label: "检测状态" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                class: [
                                  "stateCss",
                                  scope.row.checkState == 1
                                    ? "checkingCss"
                                    : "checkingCompleteCss",
                                ],
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.checkState == 1
                                      ? "检测中"
                                      : "检测完成"
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "count", label: "号码数量" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.count || "--")),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "highNum", label: "优质号码" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.highNum || "--")),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "silenceNum", label: "沉默号" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.silenceNum || "--")),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "emptyNum", label: "空号" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.emptyNum || "--")),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "riskNum", label: "风险号" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.riskNum || "--")),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "type", label: "操作", width: "58" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  disabled: scope.row.checkState == 1,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.goDetail(
                                      scope.row.id,
                                      scope.row.name
                                    )
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm.list.tableData.length
                ? _c("pagination", {
                    key: _vm.list.pageNum,
                    attrs: {
                      pageNum: _vm.list.pageNum,
                      pageSize: _vm.list.pageSize,
                      total: _vm.list.total,
                    },
                    on: {
                      sizeChange: _vm.handleSizeChange,
                      currentChange: _vm.handleCurrentChange,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c("robot"),
      _c("right-float", { ref: "rightFloat", attrs: { globalRfType: true } }),
      _c("CleaingDetail", { ref: "CleaingDetail" }),
      _c("ActionStaffDialog", {
        ref: "ActionStaffDialog",
        on: { getBindAccountObj: _vm.getBindAccountObj },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", { staticClass: "addIcon" }, [
      _c("img", {
        attrs: { src: require("@/assets/icon/add_icon.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }